
import { useEffect } from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import ResumeUpload from "./resume/ResumeUpload";
import { useResumeForm } from "@/hooks/resume/useResumeForm";
import ResumeFormAlerts from "./resume/form-sections/ResumeFormAlerts";
import ResumeSelection from "./resume/form-sections/ResumeSelection";
import JobDetailsFormRefactored from "./resume/form-sections/JobDetailsFormRefactored";
import ResumeFormActions from "./resume/form-sections/ResumeFormActions";

interface ResumeFormProps {
  onTabChange: (tab: string) => void;
}

const ResumeForm = ({ onTabChange }: ResumeFormProps) => {
  const {
    isUploading,
    setIsUploading,
    isProcessing,
    originalFilename,
    jobTitle,
    company,
    jobDescription,
    uploadComplete,
    apiError,
    selectedResumeId,
    isDuplicateResume,
    isFormValid,
    originalResumes,
    handleUploadComplete,
    handleResumeSelect,
    handleDeleteFromForm,
    handleOptimize,
    setJobTitle,
    setCompany,
    setJobDescription,
    refetchOriginalResumes
  } = useResumeForm(onTabChange);

  // Refresh original resumes when the component mounts
  useEffect(() => {
    refetchOriginalResumes();
  }, []);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Optimize a New Resume</CardTitle>
        <CardDescription>
          Select an existing resume or upload a new one, then enter job details to create an optimized version
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <ResumeFormAlerts 
          apiError={apiError}
          isDuplicateResume={isDuplicateResume}
        />
        
        <ResumeSelection
          originalResumes={originalResumes}
          selectedResumeId={selectedResumeId}
          onResumeSelect={handleResumeSelect}
          onDelete={handleDeleteFromForm}
          refetchOriginalResumes={refetchOriginalResumes}
        />
        
        {/* Only show upload section if no resume is selected */}
        {!selectedResumeId && (
          <ResumeUpload 
            isUploading={isUploading}
            setIsUploading={setIsUploading}
            onUpload={handleUploadComplete}
            uploadComplete={uploadComplete}
            filename={originalFilename}
          />
        )}
        
        <JobDetailsFormRefactored
          jobTitle={jobTitle}
          company={company}
          jobDescription={jobDescription}
          onJobTitleChange={setJobTitle}
          onCompanyChange={setCompany}
          onJobDescriptionChange={setJobDescription}
        />
      </CardContent>
      <CardFooter>
        <ResumeFormActions
          isProcessing={isProcessing}
          isUploading={isUploading}
          isFormValid={isFormValid}
          onOptimize={handleOptimize}
        />
      </CardFooter>
    </Card>
  );
};

export default ResumeForm;
